import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { AnimatedBanner } from "../../AnimatedBanner/AnimatedBanner";
import { ImpBanner } from "../Components/Conductor/ImpBanner";
import { useGetBannerContentByViewport } from "./__internal__/useGetBannerContentByViewport";
export var ImpAnimatedBanner = function(param) {
    var banners = param.banners;
    var _useGetBannerContentByViewport = useGetBannerContentByViewport(banners), bannerContents = _useGetBannerContentByViewport.bannerContents, bannerNames = _useGetBannerContentByViewport.bannerNames;
    return /*#__PURE__*/ _jsx(AnimatedBanner, {
        banners: bannerContents.map(function(banner, i) {
            return /*#__PURE__*/ _jsx(ImpBanner, {
                message: banner
            }, i);
        }),
        faireValuesBannerNames: bannerNames
    });
};
